"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Rate = _interopRequireDefault(require("./Rate"));

var _default = _Rate.default;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/rc-rate/lib/index.js
// module id = 1011
// module chunks = 0